import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { brand } from '../config/brand';
import { useLanguage } from '../i18n/LanguageContext';

const initialForm = {
  firstName: '',
  lastName: '',
  organization: '',
  email: '',
  phone: '',
  message: '',
  website: '',
  agreement: false,
};

function Contacts() {
  const { t } = useLanguage();
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState('idle');
  const [feedback, setFeedback] = useState('');

  const updateField = (event) => {
    const { name, value, checked, type } = event.target;
    setForm((current) => ({ ...current, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!form.agreement) {
      setStatus('error');
      setFeedback('agreementError');
      return;
    }

    setStatus('loading');
    setFeedback('');
    const payload = {
      contact_message: {
        first_name: form.firstName,
        last_name: form.lastName,
        organization: form.organization,
        email: form.email,
        phone: form.phone,
        message: form.message,
        website: form.website,
      },
    };

    try {
      const response = await fetch('/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error('send_failed');
      setForm(initialForm);
      setStatus('success');
      setFeedback('success');
    } catch (_error) {
      setStatus('error');
      setFeedback('error');
    }
  };

  return (
    <section className="page-section contact-page">
      <div className="shell contact-layout">
        <div className="contact-info">
          <div className="page-heading">
            <p className="eyebrow">{t.contactsPage.eyebrow}</p>
            <h1>{t.contactsPage.title}</h1>
            <p>{t.contactsPage.lead}</p>
          </div>

          <div className="contact-list">
            <a href={brand.contact.phoneHref}><small>{t.contactsPage.phone}</small><strong>{brand.contact.phone}</strong><span>{t.contactsPage.call}</span></a>
            <a href={`mailto:${brand.contact.email}`}><small>{t.contactsPage.email}</small><strong>{brand.contact.email}</strong><span>{t.contactsPage.write}</span></a>
            <a href={brand.contact.mapUrl} target="_blank" rel="noreferrer"><small>{t.contactsPage.office}</small><strong>{t.contactsPage.address}</strong><span>{t.contactsPage.map}</span></a>
          </div>

          <div className="requisites">
            <p className="footer-title">{t.contactsPage.requisites}</p>
            <dl>
              <div><dt>{t.contactsPage.requisitesLabels[0]}</dt><dd>{t.footer.company}</dd></div>
              <div><dt>{t.contactsPage.requisitesLabels[1]}</dt><dd>130 340 000 650</dd></div>
              <div><dt>{t.contactsPage.requisitesLabels[2]}</dt><dd>KZ 368560000005765898</dd></div>
              <div><dt>{t.contactsPage.requisitesLabels[3]}</dt><dd>АГФ АО «Банк ЦентрКредит»</dd></div>
              <div><dt>{t.contactsPage.requisitesLabels[4]}</dt><dd>KCJBKZKX</dd></div>
              <div><dt>{t.contactsPage.requisitesLabels[5]}</dt><dd>Шайхиева Майра Талгатовна</dd></div>
            </dl>
          </div>
        </div>

        <div className="contact-form-card">
          <div className="contact-form-card__heading">
            <span className="eyebrow">{t.contactsPage.formEyebrow}</span>
            <h2>{t.contactsPage.formTitle}</h2>
            <p>{t.contactsPage.requiredHint}</p>
          </div>

          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-grid">
              <label>{t.contactsPage.firstName}<input name="firstName" value={form.firstName} onChange={updateField} required maxLength="80" autoComplete="given-name" /></label>
              <label>{t.contactsPage.lastName}<input name="lastName" value={form.lastName} onChange={updateField} maxLength="80" autoComplete="family-name" /></label>
            </div>
            <label>{t.contactsPage.organization}<input name="organization" value={form.organization} onChange={updateField} maxLength="160" autoComplete="organization" /></label>
            <div className="form-grid">
              <label>{t.contactsPage.phoneRequired}<input type="tel" name="phone" value={form.phone} onChange={updateField} required maxLength="40" placeholder="+7 777 000 00 00" autoComplete="tel" /></label>
              <label>{t.contactsPage.emailRequired}<input type="email" name="email" value={form.email} onChange={updateField} required maxLength="254" autoComplete="email" /></label>
            </div>
            <label>{t.contactsPage.message}<textarea name="message" value={form.message} onChange={updateField} required maxLength="5000" rows="6" placeholder={t.contactsPage.messagePlaceholder} /></label>
            <label className="honeypot" aria-hidden="true">Website<input name="website" value={form.website} onChange={updateField} tabIndex="-1" autoComplete="off" /></label>
            <label className="agreement">
              <input type="checkbox" name="agreement" checked={form.agreement} onChange={updateField} />
              <span>{t.contactsPage.agreementBefore} <Link to="/privacy" target="_blank">{t.contactsPage.agreementLink}</Link>.</span>
            </label>
            {feedback && (
              <div className={`form-feedback form-feedback--${status}`} role="status">
                {t.contactsPage[feedback].replace('{phone}', brand.contact.phone)}
              </div>
            )}
            <button className="button button--primary button--wide" type="submit" disabled={status === 'loading'}>
              {status === 'loading' ? t.contactsPage.sending : t.contactsPage.submit}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contacts;
